import { AxiosError, AxiosResponse } from 'axios'
import { getInstance } from './instance'
import { WithRecordResponse, WithResponse } from '../models/Response'
import {
  DurationOption,
  EditPixel,
  IntegrationData,
  PixelAdvancedSetting,
  PixelConversionAttribution,
  PixelInfoPayload,
  PixelPiggyBack,
} from '../models/Pixel'
import { PixelConversionInfo } from '../models/Conversion'

export const createPixelConversion = async (pixelInfo: PixelInfoPayload) => {
  try {
    const response: AxiosResponse<WithResponse<PixelConversionInfo>> =
      await getInstance().post('/v3/conversion/pixel/add', pixelInfo)
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const editPixelConversion = async (pixelInfo: EditPixel) => {
  try {
    const response: AxiosResponse<WithRecordResponse<EditPixel>> =
      await getInstance().patch('/v3/conversion/pixel/update', pixelInfo)
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const getPixelConversionAttributionTypes = async () => {
  try {
    const response: AxiosResponse<
      WithRecordResponse<PixelConversionAttribution[]>
    > = await getInstance().get(
      '/v3/conversion/static/conversion-attribution-type'
    )
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const getPixelConversionPiggybackTypes = async () => {
  try {
    const response: AxiosResponse<WithRecordResponse<PixelPiggyBack[]>> =
      await getInstance().get('/v3/conversion/static/conversion-piggyback-type')
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const getPixelConversionAdvancedSettings = async () => {
  try {
    const response: AxiosResponse<WithRecordResponse<PixelAdvancedSetting[]>> =
      await getInstance().get(
        '/v3/conversion/static/pixel/conversion-default-advanced-setting-data'
      )
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const sendEmail = async (integrationData: IntegrationData) => {
  try {
    const response: AxiosResponse<WithResponse<string>> =
      await getInstance().post(
        '/v3/conversion/pixel/send-email',
        integrationData
      )
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

const getDurationOptionValues = () => [
  { label: 'Days', value: 'Day' },
  { label: 'Hours', value: 'Hour' },
]

export const getDurationOptions = async () => {
  try {
    const response: DurationOption[] = getDurationOptionValues()
    return response
  } catch (e) {
    return null
  }
}
